/**
 * orga-app-api - kontaktverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Kontakt { 
    beschreibung?: string;
    email?: string;
    firma?: string;
    name?: string;
    vorname?: string;
    funktionsbereich_id: string;
    kontakt_id: string;
    mandant_id: string;
    modified_on_utc?: Date;
    modified_user_id?: string;
}

